<template>
  <div>
    <div v-if="isLocationLoading" class="landing-invitation-bnk__loading">
      <div v-inview:animate="'fadeIn'">
        <div class="section__loading__logo">
          <img src="@/assets/images/logo-logo-fundanow-bb.svg" alt="로고"/>
          <img src="@/assets/icon/close.svg"/>
          <img src="@/assets/images/landing/bnk-logo.png" alt="bnk로고"/>
        </div>
      </div>
      <h1>BNK경남은행으로</h1>
      <h1>이동 중...</h1>
      <p>잠시만 기다려주세요!</p>
    </div>
    <div v-else class="landing-invitation-bnk">
      <div class="section__info">
        <div class="section__info__title">
          <div class="logo slow" v-inview:animate="'fadeIn'">
            <div class="logo__wrapper">
              <img src="@/assets/images/main/SectionTitle/logo.svg" alt="로고"/>
              <img src="@/assets/icon/close.svg"/>
              <img src="@/assets/images/landing/bnk-logo.png" alt="bnk로고"/>
            </div>
          </div>
          <p> 대한민국 1등 자영업자 전문 금융 플랫폼 </p>
        </div>
        <div class="section__info__content">
          <div class="section__info__content__back"></div>
          <div class="section__info__content__text__wrapper">
            <div class="section__info__content__text phone slow" v-inview:animate="'fadeInUp'">
              <p>
                누구보다 어려운 시기를 보내고 계신
                  대한민국 자영업 사장님께, 응원을 보내요!
              </p>
              <p>
                  펀다나우에서, BNK경남은행과 함께
                  비대면 사잇돌 대출을 신청 받습니다!
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="section__condition">
        <div class="section__condition__container">
          <h1 class="strong">사잇돌 대출</h1>
          <h2>나도 받을 수 있을까?</h2>
          <div class="section__conditions__wrapper slow delay-500ms" v-inview:animate="'fadeIn'">
            <div>
              <div class="item">
                <span>사업기간</span>
                <span><span class="strong">6개월</span> 이상</span>
              </div>
            </div>
            <div class="delay-100ms" v-inview:animate="'fadeIn'">
              <div class="item">
                <span>연소득</span>
                <span><span class="strong">1,000만원</span> 이상</span>
              </div>
            </div>
            <div class="delay-250ms" v-inview:animate="'fadeIn'">
              <div class="item">
                <span>신용평점</span>
                <span>
                  <span class="strong">520점</span> 이상
                  <span class="funda-gray--text">*</span>
                </span>
              </div>
              <p class="description">* KCB기준</p>
            </div>
          </div>
          <h3>라면, 지금 바로 신청해보세요!</h3>
        </div>
      </div>
      <div class="section__average">
        <div class="section__average__container">
          <h3>
            <span class="blue strong">펀다나우</span>와 함께하는 사장님들은
          </h3>
          <h3>
            평균적으로 <span class="strong"><ICountUp :endVal="1800" :delay="1500"/>만원</span>의 자금을
          </h3>
          <h3>
            사용하고 있어요!
          </h3>
        </div>
      </div>
      <div class="section__footer">
        <div class="section__footer__wrapper">
          <button
            type="button"
            v-inview:animate="'fadeInUp'"
            @click="goToBnk"
          >
            <div>
              <span>1분이면 끝나는 자금 신청!</span>
              <img src="@/assets/icon/arrow-right-black.svg" />
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isLocationLoading: false
    }
  },
  methods: {
    goToBnk() {
      this.isLocationLoading = true
      setTimeout(_ => {
        location.href = 'https://bit.ly/3v6vckm'
        setTimeout(_ => {
          this.isLocationLoading = false
        }, 1000)
      }, 2000)
    }
  }
}
</script>
<style lang="scss" scoped>
.landing-invitation-bnk {
  // background-image: url('../../../assets/images/main/bg-fundanow-cash-02.svg');

  .strong {
    font-weight: 900;
    &--medium {
      font-size: 1.1em !important;
      font-weight: 700;
    }
  }
  .funda-blue--text {
    color: #1baaf1;
  }
  .funda-gray--text {
    color: #727d8c;
  }

  &__loading {
    margin-top: 40px;
    text-align: center;

    .section__loading__logo {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 80px;

      img:nth-child(2) {
        margin: 0 5px;
        width: 15px;
      }
    }
    h1 {
      font-weight: 900;
      padding: 0 20px;
      word-break: keep-all;
      font-size: 28px;
    }
    p {
      margin-top: 40px;
    }
  }

  .section__info {
    min-height: 400px;
    background-color: #f2f9ff;

    &__title {
      background-color: #1baaf1;
      padding: 40px 20px;
      padding-bottom: 30px;
      .logo__wrapper {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;

        img:nth-child(2) {
          margin: 0 5px;
          width: 15px;
        }
      }

      p {
        margin-top: 4px;
        font-size: 10px;
        font-weight: 500;
        text-align: center;
      }
    }
    &__content {
      position: relative;
      &__back {
        background-color: #1baaf1;
        height: 100px;
      }
      &__text {
        &__wrapper {
          position: absolute;
          top: 0;
          padding: 0 15px;
          max-width: 420px;
          margin-left: auto;
          margin-right: auto;
          left: 0;
          right: 0;
        }
        padding: 40px 30px;
        text-align: center;
        background-color: white;
        box-shadow: 12px 12px 20px 0 rgba(0, 0, 0, 0.16);
        border-radius: 8px;
        p:first-child {
          margin-bottom: 20px;
        }
        p {
          line-height: 22px;
          word-break: keep-all;
        }
      }
    }
  }

  .section__condition {
    padding-bottom: 60px;
    background-color: #f2f9ff;

    &s__wrapper {
      margin: 30px 20px;

      .description {
        text-align: right;
        font-size: 13px;
        margin-top: 5px;
        color: #727d8c;
      }

      & > div:not(:last-child) {
        margin-bottom: 15px;
      }

      & .item {
        background-color: white;
        padding: 20px;
        border-radius: 4px;
        box-shadow: 0 8px 16px 0 rgba(32, 40, 47, 0.1);
        display: flex;
        justify-content: space-between;
        align-items: center;

        & > span:first-child {
          color: #727d8c;
          font-size: 18px;
          font-weight: 700;
        }
        & > span:last-child {
          color: #333333;
          font-size: 18px;
          font-weight: 700;
          display: flex;
          align-items: center;
          & > .strong {
            margin-right: 4px;
            font-size: 22px;
            font-weight: 900;
          }
        }
      }
    }

    &__container {
      max-width: 400px;
      text-align: center;
      margin: 0 auto;
    }
  }

  .section__average {
    padding-top: 80px;
    padding-bottom: 180px;
    // background-color: white;
    background-color: #f2f9ff;

    &__container {
      max-width: 400px;
      text-align: center;
      margin: 0 auto;
      h3 {
        font-weight: 500;
        .blue {
          color: #1baaf1;
        }
      }
    }
  }

  .section__footer {
    margin-bottom: 10px;
    position: fixed;
    bottom: 0;
    width: 100%;
    &__wrapper {
      padding: 20px;
      text-align: center;
    }
    button {
      margin: 0 auto;
      width: 100%;
      max-width: 400px;
      height: 64px;
      padding: 15px 15px;
      border-radius: 6px;
      font-size: 18px;
      font-weight: 900;
      box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.14);
      background-color: #ffe500;
      color: #252525;

      div {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
